import React, { useState } from 'react';

function AddInvestmentDialog({ open, onClose, onAdd, cryptoSymbol, exchanges = [], cryptos = [], mode }) {
  // mode: undefined (crypto), 'exchange' (exchange)
  const [exchange, setExchange] = useState('');
  const [crypto, setCrypto] = useState('');
  const [quantity, setQuantity] = useState('');
  const [amount, setAmount] = useState('');
  const [cryptoFilter, setCryptoFilter] = useState('');
  const [exchangeFilter, setExchangeFilter] = useState('');
  const [error, setError] = useState('');

  // For filtering
  const filteredExchanges = Array.isArray(exchanges) ? exchanges.filter(e => e && e.toLowerCase().includes(exchangeFilter.toLowerCase())) : [];
  // Support cryptos as array of objects or strings
  const normalizedCryptos = Array.isArray(cryptos) && cryptos.length > 0 && typeof cryptos[0] === 'object'
    ? cryptos.map(c => ({
        code: c.code?.toUpperCase() || '',
        symbol: c.symbol?.toUpperCase() || '',
        name: c.name || '',
      }))
    : Array.isArray(cryptos) ? cryptos.map(c => ({ code: String(c).toUpperCase(), symbol: String(c).toUpperCase(), name: String(c) })) : [];

  const cryptoFilterLower = cryptoFilter.toLowerCase();
  // Filtrage puis déduplication stricte par symbol+code+name
  const filteredCryptosRaw = normalizedCryptos.filter(c =>
    (c.symbol && c.symbol.toLowerCase().includes(cryptoFilterLower)) ||
    (c.code && c.code.toLowerCase().includes(cryptoFilterLower)) ||
    (c.name && c.name.toLowerCase().includes(cryptoFilterLower))
  );
  const seen = new Set();
  const filteredCryptos = filteredCryptosRaw.filter(c => {
    const key = `${c.symbol}__${c.code}__${c.name}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // In exchange/portfolio mode, crypto is selected
    // In crypto mode, exchange is selected, crypto is fixed
    let selectedSymbol = (mode === 'exchange' || mode === 'portfolio') ? crypto : cryptoSymbol;
    // On s'assure que c'est bien le symbol (ex: TAO)
    if (Array.isArray(cryptos) && cryptos.length > 0 && typeof cryptos[0] === 'object') {
      const found = cryptos.find(c => c.symbol?.toUpperCase() === selectedSymbol);
      if (found && found.symbol) selectedSymbol = found.symbol;
    }
    const selectedExchange = mode === 'exchange' ? (exchanges[0] || '') : exchange;
    if (!selectedSymbol || !selectedExchange || !quantity || !amount) {
      setError('Tous les champs sont obligatoires.');
      return;
    }
    if (isNaN(quantity) || isNaN(amount) || Number(quantity) <= 0 || Number(amount) <= 0) {
      setError('Quantité et montant doivent être des nombres positifs.');
      return;
    }
    setError('');
    onAdd({
      cryptoSymbol: selectedSymbol,
      exchangeCode: selectedExchange,
      investmentQuantity: Number(quantity),
      investmentAmountEur: Number(amount)
    });
  };

  // Réinitialise la sélection à chaque ouverture du dialog
  React.useEffect(() => {
    if (open) setCrypto('');
  }, [open]);

  if (!open) return null;
  return (
    <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.35)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <form onSubmit={handleSubmit} style={{background:'var(--color-surface,#fff)',color:'var(--color-text-main,#222)',borderRadius:12,padding:32,minWidth:320,maxWidth:'90vw',boxShadow:'0 4px 32px #0003',textAlign:'center'}}>
        <div style={{fontSize:20,fontWeight:600,marginBottom:16}}>Ajouter un investissement</div>
        {(mode === 'exchange' || mode === 'portfolio') ? (
          <div style={{marginBottom:16}}>
            <label style={{fontWeight:500}}>Crypto</label><br/>
            <input placeholder="Filtrer..." value={cryptoFilter} onChange={e=>setCryptoFilter(e.target.value)} style={{width:'90%',padding:6,marginTop:4,marginBottom:4,borderRadius:6,border:'1px solid #bbb'}} />
            <select value={crypto} onChange={e=> setCrypto(e.target.value)} style={{width:'90%',padding:8,borderRadius:6,border:'1px solid #bbb'}} required>
              <option value="">Choisir une crypto</option>
              {filteredCryptos.map(c => (
                <option key={`${c.symbol}__${c.code}__${c.name}`} value={c.symbol}>
                  {c.symbol}{c.name ? ` - ${c.name}` : ''}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div style={{marginBottom:16}}>
            <label style={{fontWeight:500}}>Crypto</label><br/>
            <input value={cryptoSymbol} disabled style={{width:'90%',padding:8,marginTop:4,borderRadius:6,border:'1px solid #bbb',background:'#eee',color:'#888'}} />
          </div>
        )}
        <div style={{marginBottom:16}}>
          <label style={{fontWeight:500}}>Quantité</label><br/>
          <input value={quantity} onChange={e=>setQuantity(e.target.value)} style={{width:'90%',padding:8,marginTop:4,borderRadius:6,border:'1px solid #bbb'}} required type="number" min="0" step="any" />
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontWeight:500}}>Montant investi (€)</label><br/>
          <input value={amount} onChange={e=>setAmount(e.target.value)} style={{width:'90%',padding:8,marginTop:4,borderRadius:6,border:'1px solid #bbb'}} required type="number" min="0" step="any" />
        </div>
        {mode !== 'exchange' && Array.isArray(exchanges) && exchanges.length > 0 && (
          <div style={{marginBottom:16}}>
            <label style={{fontWeight:500}}>Exchange</label><br/>
            <input placeholder="Filtrer..." value={exchangeFilter} onChange={e=>setExchangeFilter(e.target.value)} style={{width:'90%',padding:6,marginTop:4,marginBottom:4,borderRadius:6,border:'1px solid #bbb'}} />
            <select value={exchange} onChange={e=>setExchange(e.target.value)} style={{width:'90%',padding:8,borderRadius:6,border:'1px solid #bbb'}} required>
              <option value="">Choisir un exchange</option>
              {filteredExchanges.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>
        )}
        {error && <div style={{color:'#c62828',marginBottom:12}}>{error}</div>}
        <button type="button" onClick={onClose} style={{fontSize:16,padding:'10px 28px',borderRadius:8,background:'#eee',color:'#333',border:'none',cursor:'pointer',marginRight:16}}>Annuler</button>
        <button type="submit" style={{fontSize:16,padding:'10px 28px',borderRadius:8,background:'#1976d2',color:'#fff',border:'none',cursor:'pointer'}}>Ajouter</button>
      </form>
    </div>
  );
}

export default AddInvestmentDialog;
